<a
  id="read-comment-{{ comment.id }}"
  href="javascript:void(0);"
  class="mark-read-action"
  *ngIf="!comment.readUserName && handlePermissionComment() === true"
  (click)="readComment(comment);">
  <img width="25px" [matTooltip]="'Marcar como lido'" alt="Marcar como lido"  src="./assets/img/check.svg" />
</a>
